import { ExpandableTable as ExpandableTableType, TableCellType } from 'generated/graphql';

export const PRINT_LABELS_TABLE_ACTION_CODE = 'printLabels';

export const isLeadingRowSelection = (actions?: { code: string }[] | null): boolean =>
  !!actions?.some((action) => action.code === PRINT_LABELS_TABLE_ACTION_CODE);

/** Appends rowIds to the JSON `ids` array of a `dialog:form` URL, after the IDs the backend put there. */
export const appendFormUrlIds = (url: string, rowIds: string[]): string => {
  const [base, search = ''] = url.split('?');
  const params = new URLSearchParams(search);
  const ids = JSON.parse(params.get('ids') ?? '[]') as string[];
  params.set('ids', JSON.stringify([...ids, ...rowIds]));
  return `${base}?${params.toString()}`;
};

export const updateExpandableTableFields = (
  table: ExpandableTableType,
  cellIndex: number,
  rowId: string,
  newValue: string,
): ExpandableTableType => ({
  ...table,
  groups: table.groups.map((group) => ({
    ...group,
    rows: group.rows.map((row) => ({
      ...row,
      cells: row.cells.map((cell, i) => ({
        ...cell,
        value: row.id === rowId && i === cellIndex ? newValue : cell.value,
      })),
    })),
  })),
});

// Temp function
// Used in EditShipment
// Updates all the block/field table select fields when the user modifies the block/field select fields in the form
export const updateExpandableTableBlockFields = (
  table: ExpandableTableType,
  newValue: string,
  blockFieldColIndex: number,
): ExpandableTableType => {
  return {
    ...table,
    groups: table.groups.map((group) => ({
      ...group,
      rows: group.rows.map((row) => ({
        ...row,
        cells: row.cells.map((cell, i) => ({
          ...cell,
          value: i === blockFieldColIndex ? newValue : cell.value,
        })),
      })),
    })),
  };
};

// Temp function
// Checks if the table field at some index is a block/field select field
// Used on EditShipment
export const isTableBlockField = (blockFieldColIndex: number, cellIndex: number): boolean => {
  return blockFieldColIndex === cellIndex;
};

export const getTableFieldValues = (
  table: ExpandableTableType,
  columnCode: string,
): { rowId: string; value: string }[] => {
  const columnIndex = table.columns.findIndex(
    (column) =>
      column.code === columnCode &&
      (column.cellType === TableCellType.Input || column.cellType === TableCellType.InputCurrency),
  );
  if (columnIndex === -1) {
    return [];
  }
  return table.groups
    .flatMap((group) => group.rows)
    .map((row) => ({
      rowId: row.id,
      value: row.cells[columnIndex].value,
    }));
};

const table = {
  updateExpandableTableFields,
  getTableFieldValues,
};

export default table;
